import React, {useEffect, useState} from "react";
import cx from "classnames";
import {formatNumber} from "@utils/format";

export function NumberFilter(props: { className: string, placeholder: string, min?: number, max?: number, step?: number, value?: number, acceptManualInput: boolean, onChange?: (e: number) => void, onChanged?: (e: number) => void }) {

    const [value, setValue] = useState<number>(props.value || 0);

    const thousandSeparator = formatNumber(1000).replace(/[0-9]/g, '');
    const decimalSeparator = formatNumber(1.1, {minimumFractionDigits: 1, maximumFractionDigits: 1}).replace(/[0-9]/g, '');
    const regexEscape = (s: string) => s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    const localeStringToNumber = (e: string): number => Number(e.replace(new RegExp('\\' + thousandSeparator, 'g'), '').replace(new RegExp('\\' + decimalSeparator), '.'))


    useEffect(() => {
        setValue(props.value ?? 0);
    }, [props.value]);

    const curateInput = (input: string): string => {
        if (input === '') {
            return '';
        }
        const value = localeStringToNumber(input.replace(new RegExp('[^0-9' + regexEscape(thousandSeparator) + regexEscape(decimalSeparator) + '-]', 'g'), ''));
        if (props.min && value < props.min) {
            return formatNumber(props.min);
        }
        if (props.max !== undefined && value > props.max) {
            return formatNumber(props.max);
        }
        return formatNumber(value);
    }

    const roundToStep = (value: number, step: number): number => {
        return Math.round(value / step) * step;
    }

    return <div className={cx("flex items-center gap-2 flex-col", props.className)}>
        <input
            className="w-full"
            type="range"
            min={props.min}
            max={props.max}
            step={props.step}
            value={value}
            onChange={(e) => {
                setValue(localeStringToNumber(curateInput(e.target.value)));
                props.onChanged?.(localeStringToNumber(curateInput(e.target.value)));
            }}
            tabIndex={-1}
        />
        <input
            className={cx("p-3 rounded-md border border-2", "bg-gray-100 border-gray-200 dark:bg-gray-500 dark:border-gray-700 dark:text-gray-100", "focus:outline-none focus:shadow-outline", "placeholder:font-normal placeholder:text-gray-400 placeholder:dark:text-gray-300", props.className)}
            type="text"
            placeholder={props.placeholder}
            value={formatNumber(value)}
            onInput={(e) => {
                setValue(localeStringToNumber(curateInput((e.target as HTMLInputElement).value)));
            }}
            onChange={(e) => {
                if (props.onChanged) {
                    setTimeout(() => {
                        props.onChanged?.(roundToStep(localeStringToNumber(curateInput(e.target.value)), props.step || 1));
                        setValue(roundToStep(localeStringToNumber(curateInput(e.target.value)), props.step || 1));
                    }, 1000);
                }
            }}
            onKeyDown={(e) => {
                if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                    const step = props.step || 1;
                    const delta = e.key === 'ArrowUp' ? step : -step;
                    const newValue = Math.min(Math.max(value + delta, props.min || 0), props.max || 0);
                    setValue(newValue);
                    props.onChanged?.(newValue);
                    e.preventDefault();
                    e.stopPropagation();
                }
            }}
        />
    </div>
}
